import React from 'react';
import sidebarStyles from '~/components/organisms/instantSearch/instantSearchSidebar.module.scss';
import { ResultFullText } from '~/core/results/types/results.type';
import { GoToResultHandler } from '~/hooks/useGoToResult';

interface IInstantFulltextResultProps {
    result: ResultFullText;
    order: number;
    handleGoToResult: GoToResultHandler;
}

const InstantFulltextResult: React.FC<IInstantFulltextResultProps> = ({ result, order, handleGoToResult }) => {
    return (
        <li className={sidebarStyles.instantSidebarListItem}>
            <span
                onMouseDown={(e) =>
                    handleGoToResult({
                        url: result.url,
                        order,
                        resultType: 'fulltext',
                        openInNewTab: e.button === 1 || (e.button === 0 && e.ctrlKey),
                        button: e.button,
                        key: e.ctrlKey ? 'ctrl' : undefined,
                    })
                }
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.preventDefault();
                        e.stopPropagation();
                        handleGoToResult({ url: result.url, order, resultType: 'fulltext', key: 'Enter' });
                    }
                }}
                role="link"
                tabIndex={0}
            >
                <span dangerouslySetInnerHTML={{ __html: result.title }} />
            </span>
        </li>
    );
};

export default InstantFulltextResult;
